import actions from "actions";
import axios from "axios";
import FileField from "components/InputField/FileField";
import InputField from "components/InputField/InputField";
import Icon from "material-ui/Icon";
import React, { Component } from "react";
import { connect } from "react-redux";
import { BASE_URL_BACK } from "../../../cfg/defaults";
import pdfPlaceholder from "../../assets/img/pdfPlaceholder.png";
import {
  API_ADMIN_STUDY_GROUP_MATERIALS,
  ERROR_TYPE_REQUEST,
} from "../../constants/api";
import { addRequestError } from "../../actions/api";

const { createStudyGroupMaterial } = actions;

const imageExtentions = ["png", "jpg"];

const getGroupMaterialById = (id) =>
  axios.get(`${API_ADMIN_STUDY_GROUP_MATERIALS}/${id}`);

const updateGroupMaterial = (id, data) =>
  axios.put(`${API_ADMIN_STUDY_GROUP_MATERIALS}/${id}`, data);

class StudyGroupSuperhostEditMaterialForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      file: null,
      file_url: "",
      fileType: "",
    };
  }

  componentDidMount() {
    (async () => {
      try {
        const responce = await getGroupMaterialById(
          this.props.params.materialId
        );
        const { title, file_url } = responce.data.group_material;
        const [_, extention] = file_url.split(".");

        this.setState({
          title,
          file_url: `${BASE_URL_BACK}${file_url}`,
          fileType: imageExtentions.includes(extention.toLowerCase())
            ? "image"
            : "file",
        });
      } catch (error) {
        console.log(error);
      }
    })();
  }

  handleFileChange = (file) => {
    if (file)
      return this.setState({
        file,
        file_url: URL.createObjectURL(file),
        fileType: file.type,
      });
    this.setState({ file: null, file_url: "", fileType: "" });
  };

  handleTitleChange = (title) => this.setState({ title });

  handleUpdate = async () => {
    try {
      const { file, title } = this.state;
      const {
        params: { id, materialId },
        router,
      } = this.props;
      const formData = new FormData();

      formData.append("group_material[title]", title);
      if (file) formData.append("group_material[file]", file);

      await updateGroupMaterial(materialId, formData);
      router.push(`/groups/${id}/resources`);
    } catch (error) {
      this.props.dispatch(addRequestError(error.response));
    }
  };

  render() {
    const { errors } = this.props;

    return (
      <div style={{ width: "70%", margin: "auto" }}>
        <h3>Edit material</h3>
        <InputField
          label="Title"
          value={this.state.title}
          onChange={(e) => this.handleTitleChange(e.target.value)}
        />
        {errors && errors.title && (
          <div style={{ color: "red", fontSize: "0.875rem" }}>
            {errors.title[0]}
          </div>
        )}
        <div>
          <label
            className="mt-20 button_classic add_attachment_button"
            htmlFor="vebinar_attachment"
          >
            Add New File
          </label>
          <FileField
            className="col s12 vebinar_attachment"
            field_name="vebinar_attachment"
            onChange={(e) => this.handleFileChange(e.target.value)}
            label="File"
          />
          {this.state.file_url ? (
            <div className="attachment_preview_wrapper">
              <Icon
                onClick={() => this.handleFileChange()}
                className="remove_attachment"
              >
                close
              </Icon>
              <img
                src={
                  this.state.fileType.includes("image")
                    ? this.state.file_url
                    : pdfPlaceholder
                }
                className="attachment_preview"
              />
            </div>
          ) : null}
        </div>
        {errors && errors.file && (
          <div style={{ marginBottom: 10, color: "red", fontSize: "0.875rem" }}>
            {errors.file[0]}
          </div>
        )}
        <button className="button_classic" onClick={this.handleUpdate}>
          Edit
        </button>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  errors: state.errors[ERROR_TYPE_REQUEST],
});

const mapDispatchToProps = (dispatch) => ({
  createStudyGroupMaterial: (data) => dispatch(createStudyGroupMaterial(data)),
  dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupSuperhostEditMaterialForm);



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/StudyGroupSuperhostEditMaterialForm.jsx